import { gql } from 'apollo-angular';
import { Invoice } from '../../entities/payment/payment';
import { ConnectedDevice } from '../../entities/connected-device/connected-device';

export const UPLOADERS_QUERY = gql`
query getUploaders(
  $type: ConnectedDeviceType
)
{
  getUploaders: getConnectedDevices(
    filter: {
      type: $type,
      sortRequest: {
        sortProperties: ["createdDateTime"],
        sortDirection: "ASC"
      }
    }
  )
  {
    id
    name
    lastSeenDateTime
    createdDateTime
  }
}
`;

export interface GetUploadersQueryResponse {
  loading: boolean;
  getUploaders: ConnectedDevice[];
}
